import { render, staticRenderFns } from "./ListViewOld.vue?vue&type=template&id=a13fc0a0&scoped=true"
import script from "./ListViewOld.vue?vue&type=script&lang=js"
export * from "./ListViewOld.vue?vue&type=script&lang=js"
import style0 from "./ListViewOld.vue?vue&type=style&index=0&id=a13fc0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13fc0a0",
  null
  
)

export default component.exports